import React from "react";
import { Skeleton } from "../ui";
import "../ui/theme.css";

// Matches the "ADM Campaign - Skeleton loading" design (Figma 1044-17410):
// rendered inside the real sidebar; top bar shows only the avatar (no steps),
// content is a full-width title bar + a tall main block and a shorter side block.
const BuilderPageSkeleton = () => (
  <div className="cb-v2-root flex h-full flex-col bg-page">
    <header className="z-20 flex h-[72px] shrink-0 items-center justify-end border-b border-border bg-background px-6">
      <Skeleton className="h-9 w-9 rounded-full" />
    </header>
    <div className="min-h-0 flex-1 overflow-y-auto px-8 pb-10 pt-6">
      <Skeleton className="mb-6 h-8 w-full rounded-xl" />
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1fr_360px]">
        <Skeleton className="h-[640px] w-full rounded-xl" />
        <Skeleton className="h-[340px] w-full rounded-xl" />
      </div>
    </div>
  </div>
);

export { BuilderPageSkeleton };
